module.exports = __webpack_public_path__ + "img/doc.876251d2.png";